import React, { useRef, useState } from "react";
import emailjs from "@emailjs/browser";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Reaptcha from "reaptcha";

const Contact = (props) => {
  const form = useRef();
  const recaptchaRef = useRef(null);

  const { isDark } = props;

  const [isDisable, setIsDisable] = useState(true);

  const sendEmail = (e) => {
    e.preventDefault();
    if (isDisable) {
      toast.error("Please check the captcha first!");
    }
    emailjs
      .sendForm(
        "service_hf5xr7r",
        "template_gotq6yb",
        form.current,
        "user_RxpgUDQmvog3mG9QTH3Xc"
      )
      .then(
        (result) => {
          toast.success("Message Sent Successfully!", {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
          recaptchaRef.current.reset();
          setIsDisable(true);
          document.getElementById("myForm").reset();
        },
        (error) => {
          recaptchaRef.current.reset();
          setIsDisable(true);
          toast.error("Ops Message Not Sent!", {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
      );
  };

  return (
    <>
      <form
        id="myForm"
        className="contactform min-h-screen"
        ref={form}
        onSubmit={sendEmail}
      >
        <div className="row">
          <div className="col-12 col-md-6">
            <div className="form-group">
              <input type="text" name="name" placeholder="YOUR NAME" required />
            </div>
          </div>
          {/* End .col */}

          <div className="col-12 col-md-6">
            <div className="form-group">
              <input
                type="email"
                name="email"
                placeholder="YOUR EMAIL"
                required
              />
            </div>
          </div>
          {/* End .col */}

          <div className="col-12 col-md-12">
            <div className="form-group">
              <input
                type="text"
                name="subject"
                placeholder="YOUR SUBJECT"
                required
              />
            </div>
          </div>
          {/* End .col */}

          <div className="col-12">
            <div className="form-group">
              <textarea
                name="message"
                placeholder="YOUR MESSAGE"
                required
              ></textarea>
            </div>
          </div>
          {/* End .col */}

          <div className="col-12 mb-3">
            <Reaptcha
              ref={recaptchaRef}
              sitekey={"6LeZbg0eAAAAAJXZG-V0QAY21YZkX3EGmIUa97zz"}
              onVerify={(value) => {
                value && setIsDisable(false);
              }}
              onExpire={() => {
                setIsDisable(true);
              }}
              theme={isDark ? "light" : "dark"}
            />
          </div>
          <div className="col-12">
            <button type="submit" className="button">
              <span className="button-text">Send Message</span>
              <span className="button-icon fa fa-send"></span>
            </button>
          </div>
          {/* End .col */}
        </div>
      </form>
    </>
  );
};

export default Contact;
